export const servicesListData = [
	{
		id: 1,
		href: "/services/web-design-development/",
		label: "Custom Web Design & Development",
		description:
			"Elevate your brand with CraftLayer's bespoke web design and development services. We build responsive, high-performance websites tailored to direct traffic and convert visitors.",
		keywords: [
			"custom web design",
			"web development agency",
			"responsive website design",
			"UI/UX web design",
			"corporate website development",
			"frontend development",
		],
		faqs: [
			{
				question: "Do you build custom designs or use templates?",
				answer:
					"At CraftLayer, we prioritize unique, custom web designs that align perfectly with your brand identity. While we can adapt templates for budget-conscious projects, our expertise lies in crafting bespoke digital experiences from scratch.",
			},
			{
				question: "Is the website mobile-friendly?",
				answer:
					"Absolutely. We adopt a mobile-first approach for every project. Your website will be fully responsive, ensuring a seamless and engaging experience on smartphones, tablets, and desktops alike.",
			},
			{
				question: "How long does it take to design a website?",
				answer:
					"Timeline varies by complexity, but a standard corporate website typically takes 4-6 weeks from initial concept to launch/deployment, ensuring ample time for revisions and quality assurance.",
			},
		],
	},
	{
		id: 2,
		href: "/services/nextjs-development/",
		label: "Next.js Development",
		description:
			"Harness the power of the modern web with CraftLayer’s Next.js development. We build full-stack, server-rendered applications for blazing fast performance and superior SEO.",
		keywords: [
			"Next.js development services",
			"React framework experts",
			"static site generation",
			"server side rendering",
			"headless CMS integration",
			"Vercel deployment",
		],
		faqs: [
			{
				question: "Why choose Next.js over standard React?",
				answer:
					"Next.js provides Server-Side Rendering (SSR) and Static Site Generation (SSG) out of the box. This means faster page loads, better SEO rankings, and improved performance compared to traditional Client-Side Rendered (CSR) React apps.",
			},
			{
				question: "Can you migrate my existing React app to Next.js?",
				answer:
					"Yes, we specialize in migrating React applications to Next.js. We ensure a smooth transition that preserves your existing functionality while unlocking significant performance and SEO gains.",
			},
		],
	},
	{
		id: 3,
		href: "/services/react-development/",
		label: "React Development",
		description:
			"Build scalable, interactive user interfaces with our React development services. We create dynamic Single Page Applications (SPAs) optimized for speed and maintainability.",
		keywords: [
			"React.js development company",
			"single page applications",
			"frontend architecture",
			"component-based development",
			"React state management",
			"interactive web apps",
		],
		faqs: [
			{
				question: "Can you build complex single-page applications (SPAs)?",
				answer:
					"Yes, React is our tool of choice for complex SPAs. We have extensive experience building data-heavy dashboards, SaaS platforms, and interactive portals that feel like native apps.",
			},
			{
				question: "How do you handle state management?",
				answer:
					"We utilize modern state management libraries such as Zustand, Redux Toolkit, or React Context, choosing the best fit for your application's scale and complexity to ensure predictable data flow.",
			},
		],
	},
	{
		id: 4,
		href: "/services/wordpress-development/",
		label: "WordPress Development",
		description:
			"Get a secure, manageable, and scalable website with CraftLayer's custom WordPress development. We specialize in custom themes, WooCommerce, and optimized CMS solutions.",
		keywords: [
			"custom WordPress development",
			"WooCommerce experts",
			"WordPress theme development",
			"CMS development services",
			"WordPress SEO optimization",
			"plugin development",
		],
		faqs: [
			{
				question: "Can you create a custom WordPress theme?",
				answer:
					"Yes, we develop lightweight, custom WordPress themes tailored to your design specs. We avoid bloated pre-made themes to ensure your site is fast, secure, and easy to manage.",
			},
			{
				question: "Is WordPress secure?",
				answer:
					"When properly maintained, WordPress is very secure. We implement industry-leading security practices, strictly vet plugins, and provide ongoing maintenance to keep your site protected against threats.",
			},
		],
	},
	{
		id: 5,
		href: "/services/seo-search-engine-optimization/",
		label: "Search Engine Optimization (SEO)",
		description:
			"Maximize your online visibility with CraftLayer’s data-driven SEO services. We optimize technical architecture and content to drive sustainable organic traffic and higher rankings.",
		keywords: [
			"SEO services agency",
			"technical SEO audit",
			"on-page optimization",
			"keyword research strategy",
			"local SEO services",
			"organic traffic growth",
		],
		faqs: [
			{
				question: "How long does it take to see SEO results?",
				answer:
					"SEO is an investment in long-term growth. While some technical fixes yield immediate results, significant improvements in rankings and organic traffic predominantly appear within 3 to 6 months of consistent effort.",
			},
			{
				question: "What is included in your SEO audit?",
				answer:
					"Our comprehensive audit covers Technical SEO (site speed, crawlability), On-Page SEO (content, metadata), and Off-Page factors (backlinks). We deliver a clear roadmap of actionable insights to improve your visibility.",
			},
		],
	},
	{
		id: 6,
		href: "/services/performance-optimization/",
		label: "Web Performance Optimization",
		description:
			"Speed matters. Our performance optimization services target Core Web Vitals to deliver lightning-fast load times, enhancing User Experience and boosting your Google rankings.",
		keywords: [
			"website speed optimization",
			"Core Web Vitals improvement",
			"Google PageSpeed Insights",
			"reduce server response time",
			"image optimization",
			"code splitting",
		],
		faqs: [
			{
				question: "How do you improve page speed?",
				answer:
					"We employ a multi-step strategy: optimizing assets (Modern image formats, lazy loading), minifying CSS/JS, implementing advanced caching strategies, and reducing Total Blocking Time (TBT) to make your site fly.",
			},
			{
				question: "Do you focus on Core Web Vitals?",
				answer:
					"Yes, passing Core Web Vitals (LCP, INP, CLS) is crucial. We align our optimization efforts directly with these metrics to ensure you meet Google's standards for a healthy, high-performing website.",
			},
		],
	},
	{
		id: 7,
		href: "/services/ui-ux-design/",
		label: "UI/UX Design",
		description:
			"Craft meaningful digital experiences with our UI/UX design services. We blend aesthetics with psychology to create intuitive interfaces that delight users and drive engagement.",
		keywords: [
			"UI/UX design agency",
			"user interface design",
			"user experience research",
			"wireframing and prototyping",
			"mobile app design",
			"Figma design services",
		],
		faqs: [
			{
				question: "What is your design process?",
				answer:
					"Our user-centered design process encompasses discovery, research, wireframing, interactive prototyping, and usability testing. We iterate based on real feedback to ensure the final design solves user problems effectively.",
			},
			{
				question: "Do you provide design files?",
				answer:
					"Yes, you receive full ownership of the design assets. We deliver organized Figma files, style guides, and exportable assets to ensure a smooth handoff to your development team.",
			},
		],
	},
	{
		id: 8,
		href: "/services/digital-marketing/",
		label: "Digital Marketing & Strategy",
		description:
			"Accelerate your growth with data-driven digital marketing. we integrate SEO, content strategy, and performance analytics to increase your brand's reach and ROI.",
		keywords: [
			"digital marketing services",
			"content marketing strategy",
			"growth marketing",
			"social media management",
			"digital strategy agency",
			"brand awareness",
		],
		faqs: [
			{
				question: "What does your digital marketing service include?",
				answer:
					"Our holistic approach includes SEO, content creation, email marketing, and social media strategy. We build a custom roadmap to target your specific audience and business goals.",
			},
			{
				question: "How do you measure success?",
				answer:
					"We rely on hard data. We track Key Performance Indicators (KPIs) like organic traffic, conversion rates, and engagement to ensure our strategies deliver tangible ROI.",
			},
		],
	},
	{
		id: 9,
		href: "/services/website-maintenance-support/",
		label: "Website Maintenance & Support",
		description:
			"Keep your digital presence secure and running smoothly with uninterrupted website maintenance and support. We handle updates, security, and backups so you can focus on business.",
		keywords: [
			"website maintenance packages",
			"WordPress support services",
			"web security monitoring",
			"website backup solutions",
			"bug fixing and updates",
			"24/7 website monitoring",
		],
		faqs: [
			{
				question: "What is included in the maintenance package?",
				answer:
					"Our plans ensure peace of mind with scheduled plugin/core updates, daily cloud backups, real-time security scanning, uptime monitoring, and priority technical support for content changes.",
			},
			{
				question: "What happens if my site goes down?",
				answer:
					"Our automated monitoring systems alert our team instantly. We prioritize downtime incidents above all else and work urgently to diagnose and resolve the issue to get you back online.",
			},
		],
	},
];

export const generalServiceFaqs = [
	{
		question: "What services do you offer?",
		answer:
			"CraftLayer offers a full spectrum of digital services tailored for growth. These include Custom Web Development, UI/UX Design, Next.js/React Engineering, SEO Optimization, and Mobile App Development strategies.",
	},
	{
		question: "Do you specialize in any specific industries?",
		answer:
			"We are industry-agnostic but technology-focused. We have successfully partnered with clients in e-commerce, healthcare fin-tech, education, and SaaS startups, adapting our robust tech stack to meet unique sector demands.",
	},
	{
		question: "How long does a typical project take?",
		answer:
			"Project duration depends on scope. A brochure website might take 4-6 weeks, while a full-featured SaaS application could take 3-6 months. We provide a detailed Gantt chart and milestone breakdown during our initial proposal.",
	},
	{
		question: "Do you offer post-launch support?",
		answer:
			"Relationship building is key to our success. We offer comprehensive post-launch support and retainer packages to ensure your product evolves with your business, stays secure, and continues to perform optimally.",
	},
];
